import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, QueryEntity } from '@datorama/akita';

import { BorrowersState, BorrowersStore } from './borrowers.store';

@Injectable({ providedIn: 'root' })
export class BorrowersQuery extends QueryEntity<BorrowersState> {
  protected store: BorrowersStore;

  static instance: BorrowersQuery;
  dirtyChecker = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(BorrowersStore);

    super(store);
    this.store = store;

    BorrowersQuery.instance = this;
  }
}
